import "./oio-sim.css"

export const SIM_BANNER_COPY = "Simulated draft · never an order"

/** Persistent notice: nothing on this screen is an order issued by an officer. */
export function SimBanner() {
  return (
    <div className="osim-banner" role="note">
      <span className="osim-banner-dot" aria-hidden="true" />
      {SIM_BANNER_COPY}
    </div>
  )
}
